import { setDisplayErrorSnackBar } from "../../../../features/userSlice";
import { optifundDashboardService } from "../../../../services/api/optifund-dashboard.endpoints";
import store from "../../../../store";

async function runQuery(
  oauthTokenHeader: string,
  queryId: string,
  websiteSharedUid: string,
  setData: any,
  startDate?: string,
  endDate?: string,
  brand?: string,
) {
  try {
    if (!websiteSharedUid) {
      store.dispatch(
        setDisplayErrorSnackBar({
          message: "Missing website_shared_uid - cannot run this query.",
          type: "error",
        }),
      );
      return;
    }

    const response = await optifundDashboardService.runOptifundBizLayerQuery(
      oauthTokenHeader,
      queryId,
      websiteSharedUid,
      startDate,
      endDate,
      brand,
    );
    if (!response || response.status !== 200) {
      store.dispatch(
        setDisplayErrorSnackBar({
          message: "Something went wrong...",
          type: "error",
        }),
      );
      return;
    }

    const rows = response?.data?.data?.query_output;
    if (!Array.isArray(rows)) {
      store.dispatch(
        setDisplayErrorSnackBar({
          message: "Unexpected response format from the query.",
          type: "error",
        }),
      );
      return;
    }

    setData(rows);
  } catch (e: any) {
    store.dispatch(
      setDisplayErrorSnackBar({
        message: e?.parsedText || "Unknown error occurred",
        type: "error",
      }),
    );
  }
}

export const OptifundDashboardEndPointLogic = { runQuery };
